export const {
  PUBLIC_URL,
  REACT_APP_ACCESS_TOKEN_NAME,
  REACT_APP_ACCESS_TOKEN_NAME_MP,
  // APIs
  REACT_APP_API_BASE_URL,
  REACT_APP_API_BUYER_CARD_BASE_URL,
  REACT_APP_API_MY_INSTITUTION_URL,
  REACT_APP_API_OPEN_DATA_BASE_URL,
  REACT_APP_API_SECURE_PURCHASE_ORDER_BASE_URL,
  REACT_APP_API_TOTAL_DEMANDS,
  REACT_APP_API_BEHAVIOR_INDICATOR_BASE_URL,
  // End APIs
  REACT_APP_BASE_URL,
  REACT_APP_CAPACITACION_BASE_URL,
  REACT_APP_CENTROAYUDA_BASE_URL,
  REACT_APP_CHILECOMPRA_BASE_URL,
  REACT_APP_ENVIRONMENT,
  // Feature flags
  REACT_APP_FEATURE_FLAG_ANNUAL_PURCHASING_PLAN_TAB,
  REACT_APP_FEATURE_FLAG_CLAIMS_TAB,
  REACT_APP_FEATURE_FLAG_COURT_TAB,
  REACT_APP_FEATURE_FLAG_COURT_REDIRECT_BOX,
  REACT_APP_FEATURE_FLAG_DOWNLOAD_BUTTON,
  REACT_APP_FEATURE_FLAG_GENERAL_INFORMATION_TAB,
  REACT_APP_FEATURE_FLAG_LINK_TO_OPEN_DATA_INFORMATION_SECTION,
  REACT_APP_FEATURE_FLAG_PURCHASE_ORDERS_TAB,
  REACT_APP_FEATURE_FLAG_SUMMARY_SECTION,
  REACT_APP_FEATURE_FLAG_SUMMARY_SECTION_AVERAGE_DAYS,
  REACT_APP_FEATURE_FLAG_SUMMARY_SECTION_CLAIMS,
  REACT_APP_FEATURE_FLAG_SUMMARY_SECTION_PURCHASES,
  // Analytics
  REACT_APP_CAPTCHA_ENABLED,
  REACT_APP_CAPTCHA_SITE_KEY,
  REACT_APP_GOOGLE_ANALYTICS_KEY = null,
  REACT_APP_GOOGLE_ANALYTICS_SNIPPET_VERSION = null,
  REACT_APP_GOOGLE_TASK_MANAGER_KEY = null,
  REACT_APP_HOTJAR_ID = null,
  REACT_APP_HOTJAR_SNIPPET_VERSION = null,
  // End Analytics
  REACT_APP_CLAIM_CARD_BASE_URL,
  REACT_APP_CONTACT_URL,
  REACT_APP_COURT_URL,
  REACT_APP_FACEBOOK_URL,
  REACT_APP_FIRTS_NUMBER,
  REACT_APP_INSTAGRAM_URL,
  REACT_APP_LINKEDIN_URL,
  REACT_APP_MERCADO_PUBLICO_BASE_URL,
  REACT_APP_OPENED_DATA_URL,
  REACT_APP_PUBLIC_MARKET_API_URL,
  REACT_APP_SEARCH_CLAIM_INFO,
  REACT_APP_SEARCH_DETAILS_ACQUISITION_URL,
  REACT_APP_SEARCH_DETAILS_AGILE_PURCHASE_PRIVATE,
  REACT_APP_SEARCH_DETAILS_AGILE_PURCHASE_PUBLIC,
  REACT_APP_SEARCH_DETAILS_CLAIM_ID_URL,
  REACT_APP_SEARCH_DETAILS_CONTRACT_URL,
  REACT_APP_SEARCH_DETAILS_DIRECT_DEAL_URL,
  REACT_APP_SEARCH_DETAILS_GREAT_PURCHASE_URL,
  REACT_APP_SEARCH_DETAILS_MARKET_CONSULTATION_URL,
  REACT_APP_SEARCH_DETAILS_PURCHASE_ORDER_URL,
  REACT_APP_SEARCH_PURCHSE_ORDER,
  REACT_APP_SECOND_NUMBER,
  REACT_APP_SECURE_PURCHASE_ORDER_KEY,
  REACT_APP_TERMS_AND_CONDITIONS_URL,
  REACT_APP_TWITTER_URL,
  REACT_APP_YOUTUBE_URL
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod' && process.env.REACT_APP_ENVIRONMENT !== 'test'
export const isLocalEnv = process.env.REACT_APP_ENVIRONMENT === 'local' || process.env.REACT_APP_ENVIRONMENT === 'dev'
